<template>
    <span></span>
</template>

<script>
export default {
  data() {
    return {
      applicantName: '',
      recruiterName: '',
    };
  },
  created() {
    (async () => {
      await Promise.resolve()
        .then(() => this.$axios.get('/api/applicant/name'))
        .then((res) => (this.applicantName = res.data))
        .catch(() => {}); // 管理者側でログインしていた場合、エラーになるので必要
      await Promise.resolve()
        .then(() => this.$axios.get('/api/recruiter/name'))
        .then((res) => (this.recruiterName = res.data))
        .catch(() => {}); // 受験者側でログインしていた場合、エラーになるので必要
      if (this.applicantName === '' && this.recruiterName != '') {
        window.location = '/admin';
      } else if (this.applicantName != '' && this.recruiterName === '') {
        window.location = '/exam/redirect_by_status';
      } else if (this.$route.path.split('/')[1] === 'admin') {
        window.location = '/admin/login';
      } else {
        window.location = '/exam/login';
      }
    })();
  },
};
</script>
